// Formatação dos valores do DRE. `tipo` vem dos metadados do indicador
// (dreRepo.INDICADORES): 'moeda' -> R$; 'numero' -> inteiro (sacas).

const moedaFmt = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  maximumFractionDigits: 0
});

const numeroFmt = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 });

const percentFmt = new Intl.NumberFormat('pt-BR', {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1
});

export function formatValor(valor, tipo) {
  if (valor === null || valor === undefined) return '—';
  return tipo === 'moeda' ? moedaFmt.format(valor) : numeroFmt.format(valor);
}

// Variação absoluta (realizado - orçado) já formatada com sinal.
export function formatVariacao(orcado, realizado, tipo) {
  if (orcado === null || orcado === undefined || realizado === null || realizado === undefined) {
    return '—';
  }
  const delta = realizado - orcado;
  const sinal = delta > 0 ? '+' : '';
  return sinal + formatValor(delta, tipo);
}

// Variação percentual sobre o orçado (base |orçado|). null quando não calculável.
export function formatVariacaoPct(orcado, realizado) {
  if (orcado === null || orcado === undefined || realizado === null || realizado === undefined || orcado === 0) {
    return null;
  }
  const pct = ((realizado - orcado) / Math.abs(orcado)) * 100;
  const sinal = pct > 0 ? '+' : '';
  return `${sinal}${percentFmt.format(pct)}%`;
}

// Sinal da variação (para colorir): 'pos' | 'neg' | 'zero' | null.
export function sinalVariacao(orcado, realizado) {
  if (orcado === null || orcado === undefined || realizado === null || realizado === undefined) {
    return null;
  }
  const delta = realizado - orcado;
  if (delta > 0) return 'pos';
  if (delta < 0) return 'neg';
  return 'zero';
}

const meses = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
];

export function nomeMes(mes) {
  return meses[mes - 1] || String(mes);
}

export function formatDataHora(dateStr) {
  if (!dateStr) return null;
  return new Date(dateStr).toLocaleString('pt-BR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit'
  });
}
